import React from "react";
import "./index.less";
import { Row, Typography } from "antd";
import HomePageNavbarComponent from "../../../components/HomePageNavbarComponent/HomePageNavbarComponent";
import { useTranslation } from "react-i18next";
import usePublicPageSeo from "../../../hooks/global/usePublicPageSeo";
const { Title, Paragraph, Text } = Typography;

const LegalNoticePage = () => {
  const { t } = useTranslation();
  usePublicPageSeo({ path: "/legal-notices" });

  return (
    <div className="PolicyPagesCommonWrapper">
      <HomePageNavbarComponent />
      <Row justify="center" className="ContentPolicyPageWrapper">
        <div className="terms-main">
          <Title level={3} className="term-head">
            {t("legal-information")}
          </Title>
          <Paragraph className="term-comman">{t("the-current-website-text")}</Paragraph>
          <Paragraph className="term-comman">{t("the-site-is-hosted-by-ovh")}</Paragraph>
        </div>
      </Row>
    </div>
  );
};

export default LegalNoticePage;
